// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Q12U","rightAdornment":"Header_rightAdornment__uo7Jl"};